const TagType = {
  Building: 'Building',
  Company: 'Company',
  Contact: 'Contact',
};

export default TagType;
